import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bb6cca40&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bb6cca40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6cca40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb6cca40')) {
      api.createRecord('bb6cca40', component.options)
    } else {
      api.reload('bb6cca40', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bb6cca40&scoped=true&", function () {
      api.rerender('bb6cca40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20Cf3Ey87TF7x/JS/comp/GuestBox.vue"
export default component.exports